import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'buyabletests',
            name: 'buyabletest',
            class: 'Modules\\Ecommerce\\Entities\\Buyabletest',
            buyables: null
        }
    }
}